import styled from 'styled-components'

export const ColumnSelector = styled.div`
    position: relative;
`

export const ColumnSelectorButton = styled.button`
    width: 180px;
`

export const ColumnSelectorList = styled.div`
    position: absolute;
    bottom: calc(100% + 5px);
    right: 0;
    background-color: #ffffff;
    min-width: 100%;
    max-height: 300px;
    overflow: auto;
    padding: 5px;
    box-shadow: 0 0 3px 0px #c5c5c5;
    border-radius: 4px;
    z-index: 10;
`

export const ColumnSelectorOption = styled.div`
    label {
        cursor: pointer;
        user-select: none;
        width: 100%;
    }

    &:last-child {
        label {
            margin-bottom: 0;
        }
    }
`
